import React__default, { forwardRef } from 'react';

/* eslint-disable @typescript-eslint/ban-types */
function setDefaultClass(Component, defaultClass) {
    const Comp = forwardRef((props, ref) => {
        return (React__default.createElement(Component, Object.assign({}, props, { 
            // @ts-ignore
            className: `${defaultClass} ${props.className || ''}`, ref: ref })));
    });
    // @ts-ignore
    Comp.classSelector = `.${defaultClass}`;
    return Comp;
}

export { setDefaultClass };
